// Logged-in user's personal Google Meet account: status, connect, disconnect.
// Endpoint: /me/meet-account  (GET / DELETE)
// Connect flow: GET /auth/google/connect-meet-user/start → same-tab redirect.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { crmApi } from "../api/client";

const USER_MEET_KEY = ["crm", "user-meet-account"];

export function useUserMeetAccount() {
  return useQuery({
    queryKey: USER_MEET_KEY,
    queryFn: async () => {
      const { data } = await crmApi.get("/me/meet-account");
      return data;
    },
    staleTime: 30_000,
  });
}

export function useStartUserMeetConnect() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await crmApi.get("/auth/google/connect-meet-user/start");
      return data;
    },
  });
}

export function useDisconnectUserMeetAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await crmApi.delete("/me/meet-account")).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: USER_MEET_KEY });
      qc.invalidateQueries({ queryKey: ["crm", "lead-meetings"] });
    },
  });
}
